import { render, staticRenderFns } from "./the-sidebar.vue?vue&type=template&id=384301e2&scoped=true"
import script from "./the-sidebar.vue?vue&type=script&lang=ts"
export * from "./the-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./the-sidebar.vue?vue&type=style&index=0&id=384301e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384301e2",
  null
  
)

export default component.exports